import { AppComponent } from './../app.component';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { AuthService } from './../services/auth.service';
import { StorageService } from './../services/storage.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit{

  form: any = {
    email: null,
    password: null
  };

  isLoggedIn = false;
  isLoginFailed = false;
  isLoggingIn = false;
  errorMessage = '';

  redirectTo: string = '';
  redirectParams: { [key: string]: string } = {};

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private appComponent: AppComponent,
              private authService: AuthService, private storageService: StorageService) { }

  ngOnInit(): void {
    if (this.storageService.isLoggedIn()) {
      this.isLoggedIn = true;
      this.appComponent.isAuthenticated=true;
    }

    this.activatedRoute.queryParams.subscribe(params => { 
      console.log(params);
      if(params['redirectTo']) {
        this.redirectTo = params['redirectTo'];
          // Extraer todos los parámetros excepto 'redirectTo'
          const { redirectTo, ...rest } = params;
          this.redirectParams = rest;

          console.log('redirectParams:', this.redirectParams);
      }

    });
  }

  onLogin(): void {
    if (this.isLoggingIn) return;
    const { email, password } = this.form;
    this.isLoggingIn = true;
    this.isLoginFailed = false;
    this.errorMessage = '';

    this.authService.login(email, password).pipe(
      finalize(() => this.isLoggingIn = false),
    ).subscribe({
      next: data => {
        const session = this.storageService.saveUser(data);
        if (!session) {
          this.errorMessage = 'The login response was invalid. Please try again.';
          this.isLoginFailed = true;
          return;
        }

        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.appComponent.isAuthenticated=true;
        this.authService.scheduleRefresh();
        
        if(this.redirectTo) {
          this.router.navigate([this.redirectTo], { queryParams: this.redirectParams, replaceUrl: true });
        } else {
          this.router.navigate(['home'], { replaceUrl: true });
        }
      },
      error: err => {
        this.errorMessage = err?.error?.message ?? 'Login failed. Please check your credentials and try again.';
        this.isLoginFailed = true;
      }
    });
  }

}
